// extracted by mini-css-extract-plugin
export default {"head":"parfum_head__quW0X","title":"parfum_title__YjrP0","productList":"parfum_productList__FOQ5W","feed":"parfum_feed__nTXEw"};